module.exports = __webpack_public_path__ + "media/images/mr_404-02908d71.png";